import {
    ElementData,
    Exercise,
    ExerciseData,
    ExerciseElement,
    ViewMode,
} from "@/Components/Exercises/exerciseSchema";
import { ClientExercise } from "@/types/exercise";
import { WebRTC } from "@/utils/WebRTC";
import { z } from "zod";
import { booleanReturnOpSchema } from "../LogicOperation";

export type ExerciseRTCMessage<Elem extends ExerciseElement = ExerciseElement> =

        | {
              type: "elementUpdated";
              elementId: Elem["id"];
              data: ElementData<Elem>;
              options?: {
                  save?: boolean;
              };
          }
        | {
              type: "fastElementUpdate";
              elementId: Elem["id"];
              data: ElementData<Elem>;
          }
        | {
              type: "changeSlide";
              slideDirection: "next" | "previous";
              indexesVisited: number[];
          }
        | {
              type: "finished";
          };

export const baseElementSchema = z.object({
    id: z.string(),
    type: z.string(),
    onlyShowIf: z.union([booleanReturnOpSchema, z.boolean()]).optional(),
    canGoNext: z.union([booleanReturnOpSchema, z.boolean()]).optional(),
});

export type BaseElement = z.infer<typeof baseElementSchema>;

export type ElementComponentProps<Elem extends ExerciseElement> = {
    element: Elem;
    hasSiblings: boolean;
    exercise: Exercise;
    exerciseData: ExerciseData;
    clientExercise: Omit<ClientExercise, "json"> | null;
    elementData: ElementData<Elem> | undefined;
    viewMode: ViewMode;
    webRTC: WebRTC<ExerciseRTCMessage<Elem>>;
    setElementData: (
        element: Elem["id"],
        data: ElementData<Elem>,
        options?: {
            save?: boolean;
        },
    ) => ExerciseData | undefined;
    goNext: (exerciseData: ExerciseData | null) => void;
    saveExercise: () => void;
};
